import { localStorageKeys } from '../../global/constants';

const { TOKEN } = localStorageKeys;

const requestInterceptor = (configParam) => {
  const config = configParam;
  config.headers['request-startTime'] = new Date().getTime();

  const token = localStorage.getItem(TOKEN);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

export default requestInterceptor;
